import {reducer} from './reducers';

export const documents = {
    reducer,
};
